const SEND_DOCUMENT_REQUEST_COLUMNS_NAMES = {
  date: 'date',
  journal: 'journal',
  label: 'label',
  amount: 'amount',
  delete: 'delete'
};

const SEND_DOCUMENT_REQUEST_HEADER_ROW = {
  rowId: 'header',
  height: 40,
  cells: [
    {
      columnId: SEND_DOCUMENT_REQUEST_COLUMNS_NAMES.date,
      type: 'header',
      text: 'Date pièce',
      className: 'header-cell'
    },
    {
      columnId: SEND_DOCUMENT_REQUEST_COLUMNS_NAMES.journal,
      type: 'header',
      text: 'Journal',
      className: 'header-cell'
    },
    {
      columnId: SEND_DOCUMENT_REQUEST_COLUMNS_NAMES.label,
      type: 'header',
      text: 'Libellé',
      className: 'header-cell'
    },
    {
      columnId: SEND_DOCUMENT_REQUEST_COLUMNS_NAMES.amount,
      type: 'header',
      text: 'Montant',
      className: 'header-cell'
    },
    {
      columnId: SEND_DOCUMENT_REQUEST_COLUMNS_NAMES.delete,
      type: 'header',
      text: ' ',
      className: 'header-cell'
    }
  ]
};

const getDocumentRequestColumns = () => {
  const defaultColumnWidth = 150;
  const deleteColumnWidth = 50;

  return Object.keys(SEND_DOCUMENT_REQUEST_COLUMNS_NAMES).map(c => ({
    resizable: true,
    columnId: c,
    width: c === SEND_DOCUMENT_REQUEST_COLUMNS_NAMES.delete ? deleteColumnWidth : defaultColumnWidth
  }));
};

export {SEND_DOCUMENT_REQUEST_HEADER_ROW, SEND_DOCUMENT_REQUEST_COLUMNS_NAMES, getDocumentRequestColumns};
